import React from 'react'
import Product from '@page-components/Order/Products/ProductsContent/Category/Product'

import styles from './styles.module.css'

export default function Products(props) {
  const {products} = props.publication
  if (!products.length) return null

  return (
    <div className={styles.container}>
      {products.map(product => (
        <Product key={product._id} product={product} menuId={props.menuId} />
      ))}
    </div>
  )
}
